<template>
  <div class="relative flex w-full items-center">
    <input
      :id="inputId"
      v-model="content"
      :class="[
        'peer w-full px-4 py-3 text-base focus:border-gray-secondary focus:ring-1 focus:ring-gray-secondary',
        hasBorder
          ? 'border-gray-300 border'
          : 'border-0 border-transparent focus:border-0 focus:ring-0',
      ]"
      type="number"
      @keypress="handleKeyPress"
    />
    <label
      :for="inputId"
      class="peer-placeholder-shown:text-gray-500 absolute -top-2 left-2 bg-white px-2 text-xs transition-all duration-200 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-xs peer-focus:font-bold"
    >
      {{ label }}
    </label>
    <slot name="suffix" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import type { PropType, WritableComputedRef } from 'vue'

export default defineComponent({
  name: 'NumberInput',
  props: {
    modelValue: {
      type: Number as PropType<number>,
      default: undefined,
    },
    label: {
      type: String,
      default: 'Number',
    },
    inputId: {
      type: String as PropType<string>,
      required: true,
    },
    hasBorder: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:modelValue'],

  setup(props, { emit }) {
    const content: WritableComputedRef<number | undefined> = computed({
      get() {
        return props.modelValue
      },
      set(newValue: number): void {
        emit('update:modelValue', newValue)
      },
    })

    const handleKeyPress = (event: KeyboardEvent) => {
      const regex = /\d/

      if (!regex.test(event.key)) {
        event?.preventDefault()
      }
    }

    return {
      content,
      handleKeyPress,
    }
  },
})
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
